import {BasicCriteria} from '../../../../allkey/framework/parameters/BasicCriteria';

export class FlowCriteria extends BasicCriteria {
processCode: string;
visionCode: string;
}

